module.exports = __webpack_public_path__ + "media/images/sarapoint/banner-0b72c63f5880a7d47a347d5152e6fd3c.svg";